
import StudentResumeFormStore, { StudentResumeFormStoreProvider } from '../../../store/studentresumeform.store'
import DownloadStatusListDialog from '../../study-material/DownloadStatusListDialog'
import { Box, Button, Dialog, DialogContent, Typography, useTheme } from '@mui/material'
import { useLayoutContext } from '../../../../shared/contexts/layout.context'
import sessionEndedImg from '../../../../shared/assets/waiting.svg'
import { useAuthStore } from '../../../store/auth.store'
import aliveLogoImg from '../../../../shared/assets/alivelogo.png'

import { Outlet } from 'react-router-dom'
import { LoginOutlined } from '@mui/icons-material'
import SideDrawer from './UserSideDrawer'
import { observer } from 'mobx-react'
import { useCallback, useEffect, useRef } from 'react'
import Navbar from './UserNavbar'
import React from 'react'
import ResourceDownloadStatusDialog from '../../live-session/ResourceDownloadStatusDialog'
import api from '../../../service/api'
import { ERPLoginPageURL } from '../../../../shared/utils/constants.jsx'
import MaintenanceMessageBlock from '../../../../shared/components/common/MaintenanceMessageBlock.jsx'


const getModuleByPathname = ( pathname ) => {
    if ( [/^(\/student\/material)\/?$/, /^(\/student\/material\/\d+)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "materials"
    else if ( [/^(\/student\/assignment)\/?$/, /^(\/student\/assignment\/\d+)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "assignment"
    else if ( [/^(\/student\/exams)\/?$/, /^(\/student\/exams\/\d+)\/?$/, /^(\/student\/scores)\/?$/, /^(\/student\/scores\/\d+\/\d+)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "exam"
    else if ( [/^(\/student\/discussions)\/?$/, /^(\/student\/discussions\/\w+)\/?$/, /^(\/student\/my-discussions)\/?$/, /^(\/student\/my-discussions\/\w+)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "discussion"
    else if ( [/^(\/student\/resume-builder)\/?$/, /^(\/student\/resume-builder\/preview)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "resume_builder"
    else if ( [/^(\/student\/academics)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "academics"
    else if ( [/^(\/student\/subject\/\d+\/class-sessions)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "class_session"
    else if ( [/^(\/student\/subject\/\d+\/aimentor)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "aimentor"
    else if ( [/^(\/student\/subject\/\d+\/materials)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "materials"
    else if ( [/^(\/student\/subject\/\d+\/assignments)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "assignment"
    else if ( [/^(\/student\/subject\/\d+\/exams)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "exam"
    else if ( [/^(\/student\/stream)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "online_class"
    else if ( [/^(\/student\/subject\/\d+\/discussion)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "discussion"
    else if ( [/^(\/student\/subjects)\/?$/, /^(\/student\/subject\/\d+)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "subjects"
    else if ( [/^(\/student\/quiz)\/?$/, /^(\/student\/quiz\/\d+\/\d+\/attempt\/\d+)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "quiz"
    else if ( [/^(\/student\/home)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "home"
    else if ( [/^(\/student\/faq)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "faq"
    else return null
}

const UserLayout = observer( ( { navHeadText } ) => {

    const { active, setMenuState, navHeight, minSidebarCollapseWidth } = useLayoutContext()

    const AuthStore = useAuthStore()
    const { palette, theme } = useTheme()

    const previousModule = useRef( null )
    const previousModuleChangedTime = useRef( Date.now() )
    const activities = useRef( {} )

    const handleResizeOrLoad = useCallback( () => {

        if ( window.innerWidth < minSidebarCollapseWidth ) {
            setMenuState( false )
        }
        else {
            setMenuState( true )
        }
    }, [minSidebarCollapseWidth, setMenuState] )



    const registerActivities = useCallback( async ( calculateAgain = false ) => {
        try {
            const module = getModuleByPathname( active )
            let activitiesToSend = activities.current

            if ( module && calculateAgain ) {
                const now = Date.now()
                const timeSpentOnLastModule = Math.round( ( now - previousModuleChangedTime.current ) / 1000 )
                const previousModuleValue = module

                const newValues = { ...activitiesToSend }
                if ( !["subjects", "home", "faq"].includes( previousModule.current ) ) {
                    if ( !newValues[previousModuleValue] )
                        newValues[previousModuleValue] = timeSpentOnLastModule
                    else
                        newValues[previousModuleValue] = newValues[previousModuleValue] + timeSpentOnLastModule
                }
                newValues.total = newValues.total ? newValues.total + timeSpentOnLastModule : timeSpentOnLastModule
                activitiesToSend = newValues

                previousModule.current = module
                previousModuleChangedTime.current = now
            }
            await api.registerSessionTrackDetails( { activities_details: activitiesToSend, updateValue: "timeSpent" } )
            activities.current = {}
        } catch ( err ) {
            console.log( err )
        } finally {
        }
    }, [active] )

    useEffect( () => {
        if ( active !== "/" ) {
            const module = getModuleByPathname( active )

            if ( module && module !== previousModule.current ) {
                const now = Date.now()
                const timeSpentOnLastModule = Math.round( ( now - previousModuleChangedTime.current ) / 1000 )
                const previousModuleValue = previousModule.current

                if ( previousModule.current ) {
                    const newValues = { ...activities.current }
                    if ( !["subjects", "home", "faq"].includes( previousModule.current ) ) {
                        if ( !newValues[previousModuleValue] )
                            newValues[previousModuleValue] = timeSpentOnLastModule
                        else
                            newValues[previousModuleValue] = newValues[previousModuleValue] + timeSpentOnLastModule
                    }
                    newValues.total = newValues.total ? newValues.total + timeSpentOnLastModule : timeSpentOnLastModule
                    activities.current = newValues
                }

                previousModule.current = module
                previousModuleChangedTime.current = now
            }
        }
    }, [active] )

    useEffect( () => {
        window.addEventListener( 'resize', handleResizeOrLoad )
        window.addEventListener( 'load', handleResizeOrLoad )
        return () => {
            window.removeEventListener( 'resize', handleResizeOrLoad )
            window.removeEventListener( 'resize', handleResizeOrLoad )
        }
    }, [handleResizeOrLoad] )

    const navigateToSigninPage = () => {
        const redirectValue = encodeURIComponent( `${window.location.pathname}${window.location.search}` )
        window.location.href = `${ERPLoginPageURL}?redirect=${redirectValue}`
    }

    // useEffect( () => {
    //     const handleBeforeUnload = () => {
    //         if ( 'serviceWorker' in navigator && 'SyncManager' in window ) {
    //             navigator.serviceWorker.ready.then( registration => {
    //                 const module = getModuleByPathname( window.location.pathname )
    //                 let activitiesToSend = activities.current

    //                 if ( module ) {
    //                     const now = Date.now()
    //                     const timeSpentOnLastModule = Math.round( ( now - previousModuleChangedTime.current ) / 1000 )
    //                     const previousModuleValue = module
    //                     const newValues = { ...activitiesToSend }
    //                     if ( !["subjects", "home", "faq"].includes( previousModule.current ) ) {
    //                         if ( !newValues[previousModuleValue] )
    //                             newValues[previousModuleValue] = timeSpentOnLastModule
    //                         else
    //                             newValues[previousModuleValue] = newValues[previousModuleValue] + timeSpentOnLastModule
    //                     }
    //                     newValues.total = newValues.total ? newValues.total + timeSpentOnLastModule : timeSpentOnLastModule
    //                     activitiesToSend = newValues

    //                     previousModule.current = module
    //                     previousModuleChangedTime.current = now
    //                 }
    //                 if ( localStorage.getItem( 'id_token' ) )
    //                     registration.active?.postMessage( { timespent: activitiesToSend, token: localStorage.getItem( 'id_token' ) } )
    //             } ).catch( error => {
    //                 console.error( 'Error registering sync:', error )
    //             } )
    //         }
    //     }

    //     window.addEventListener( 'beforeunload', handleBeforeUnload )

    //     return () => {
    //         window.removeEventListener( 'beforeunload', handleBeforeUnload )
    //     }
    // }, [] )

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column-reverse" },
                height: "100%",
                overflow: "auto",
                background: palette.layoutBackground
            }}>
            <StudentResumeFormStoreProvider store={StudentResumeFormStore}>
                <SideDrawer closeSideMenu={() => setMenuState( false )} />
                <Box
                    sx={{
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        minWidth: "0",
                        position: "relative",
                        overflow: "auto"
                    }}>

                    <MaintenanceMessageBlock />

                    <Navbar onLogout={registerActivities} navHeadText={navHeadText} closeSideMenu={() => setMenuState( false )} openSideMenu={() => setMenuState( true )} />
                    {AuthStore.getErpSessionState !== "ended" &&
                        <Box
                            id="page-content"
                            className={theme}
                            sx={{
                                bgcolor: palette.background.default,
                                overflow: "auto",
                                borderRadius: { sm: "10px 0 0 0", xs: "0" },
                                flexGrow: 1,
                                display: "flex",
                                minWidth: "0",
                                position: "relative"
                            }}>
                            <Box
                                sx={{
                                    position: "absolute",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: 100,
                                    inset: 0,
                                    opacity: "0.1",
                                    pointerEvents: "none"
                                }}>
                                <Box
                                    component="img"
                                    src={aliveLogoImg}
                                    sx={{
                                        width: "30%",
                                        opacity: "0.4"
                                    }} />
                            </Box>
                            <Outlet />
                        </Box>
                    }
                </Box>
                <Dialog open={AuthStore.getErpSessionState === "ended"}>
                    <DialogContent >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "20px",
                                flexDirection: "column"
                            }}>
                            <Box component="img" src={sessionEndedImg} alt="Session ended!" sx={{
                                width: "200px"
                            }} />
                            <Typography variant='subtitle2' sx={{
                                textAlign: "center"
                            }}>Your session seems to have ended please login again.</Typography>
                            <Button onClick={navigateToSigninPage} startIcon={<LoginOutlined fontSize='small' />} variant='outlined' sx={{ textTransform: "capitalize" }}>Sign In</Button>
                        </Box>
                    </DialogContent>
                </Dialog>
                <DownloadStatusListDialog />
                <ResourceDownloadStatusDialog />
            </StudentResumeFormStoreProvider>
        </Box>
    )
} )

export default UserLayout
